import React, { useState } from "react";
import { Button, Card } from "antd";
import { SettingOutlined } from "@ant-design/icons";

const CardInfo = ({
  topLeftButton,
  onClick,
  showIcon,
  icon,
  onClickIcon,
  title,
  description,
  active,
  buttonTitle,
  onClickButton,
  selected,
  buttonDisabled,
  topRightButton,
  showStatus,
  onClickStatus,
}) => {
  return (
    <Card
      className={`text-center shadow-lg hover:shadow-xl rounded-lg h-full ${
        onClick ? "cursor-pointer" : ""
      }`}
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        }
      }}
      bodyStyle={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <div className="flex flex-1 mb-4">
        <div className="w-7 h-7">
          {showIcon && (
            <Button
              icon={icon || <SettingOutlined />}
              className="border-0 shadow-none"
              onClick={(e) => {
                e.stopPropagation();
                if (onClickIcon) {
                  onClickIcon();
                }
              }}
            />
          )}
          {topLeftButton}
        </div>
        <div className="flex flex-1 justify-center py-1 px-4 leading-tight">
          {title}
        </div>
        {showStatus !== false && (
          <div className="py-1">
            <div
              className={`w-4 h-4 rounded-full ${
                selected ? `bg-custom_green` : "bg-custom_lightgray"
              }`}
              onClick={(e) => {
                e.stopPropagation();
                if (onClickStatus) {
                  onClickStatus();
                }
              }}
            ></div>
          </div>
        )}
        {showStatus === false && topRightButton}
        {description && (
          <div className="flex flex-1 justify-center mt-1 mb-4 leading-tight">
            {description}
          </div>
        )}
      </div>
      {buttonTitle && (
        <Button
          type="primary"
          className={"bg-custom_primary border-custom_primary"}
          onClick={() => {
            if (onClickButton) {
              onClickButton();
            }
          }}
          disabled={buttonDisabled || false}
        >
          {buttonTitle}
        </Button>
      )}
    </Card>
  );
};

export default CardInfo;
